import { render, staticRenderFns } from "./ContentLayout.vue?vue&type=template&id=37fae3e9&scoped=true&"
import script from "./ContentLayout.vue?vue&type=script&lang=ts&"
export * from "./ContentLayout.vue?vue&type=script&lang=ts&"
import style0 from "./ContentLayout.vue?vue&type=style&index=0&id=37fae3e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fae3e9",
  null
  
)

export default component.exports